
import modules from "@/store/index.js";
import mixin from "@/mixin/index.js";
import messages from "@/constants/messages.js";
const root = { root: true };
const _isCordovaApp = mixin.methods._isCordovaApp;
let stripePromise;

const commit = function (path, args) {
    modules.commit(
        path,
        args,
        root
    );
}

const setStatusLabelText = function (error) {
    let errorMessage = {
        text: ''
    }
    if (error.readable_error_code === "RECEIPT_ALREADY_IN_USE") {
        commit('general/setConfirmModel', {
            active: true,
            alert: true,
            text: messages.PURCHASE_ANOTHER_ACCOUNT,
            callback: (_) => { },
            confirmText: mixin.methods._getLabel("CONTINUE"),
        });
    } else if (error.readable_error_code === "NETWORK_ERROR") {
        errorMessage['text'] = messages.ERROR_NETWORK;
        modules.dispatch('general/showAlert', errorMessage, root);
    } else if (!!error.readable_error_code) {
        modules.dispatch('general/showError', `${messages.ERROR} - Cod: ${error.readable_error_code}`, root);
    }
    let objectString = JSON.stringify(error, null, 4);
    console.log(`PURCHASES_ERROR: ${objectString}`);
}
document.addEventListener("deviceready", onDeviceReady, false);
function onDeviceReady(callstack = 0) {
    if (!!modules.getters['general/user']) {
        rcConfigure();
    } else if (callstack < 3) {
        setTimeout(onDeviceReady, 2000, callstack + 1);
    }
}
function rcConfigure(callback = null, args = null) {
    Purchases.setDebugLogsEnabled(true);
    Purchases.configureWith({
        appUserID: modules.getters['general/user'].uid,
        apiKey: process.env.VUE_APP_RC_SK,
        usesStoreKit2IfAvailable: false
    });
    Purchases.setEmail(modules.getters['general/user'].email);
    commit('purchases/setRcConfig', true);
    if (!!callback) {
        setTimeout(() => {
            callback(args);
        }, 2000);
    }
}
function rcConfigureOrLogin() {
    if (_isCordovaApp()) {
        if (!modules.getters['purchases/rcConfig']) {
            rcConfigure();
        } else {
            Purchases.logIn(
                modules.getters['general/user'].uid,
                _info => {
                    Purchases.setEmail(modules.getters['general/user'].email);
                },
                error => {
                    setStatusLabelText(error);
                }
            );
        }
    }
}
function displayUpsellScreen(args = null) {
    if (!modules.getters['purchases/rcConfig']) {
        return rcConfigure(displayUpsellScreen, args);
    }
    if (_isCordovaApp()) {
        Purchases.getOfferings(
            offerings => {
                const rcOffering = args.offering ? args.offering.revenueCatOffering : process.env.VUE_APP_REVENUE_CAT_VERSION_OFFERING;
                const offering = offerings.all[rcOffering];
                if (offering !== null && offering.availablePackages.length !== 0) {
                    commit('purchases/setProducts', offering.availablePackages);
                    commit('purchases/setMetadata', offering.metadata);
                    commit('purchases/setPurchasesModel', true);
                    if (args && args.openPurchasesFromMenu) {
                        setTimeout(() => {
                            commit('purchases/setOpenPurchasesFromMenu', true);
                        }, 500);
                    }
                }
            },
            error => {
                setStatusLabelText(error);
            }
        );
    }
}
const initializeStripe = async () => {
    if (!stripePromise) {
        stripePromise = await require("@stripe/stripe-js").loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    }
    return stripePromise;
};

const logEvent = (evt) => {
    modules.dispatch(
        'general/logEvent',
        { name: evt, object: { 'uid': !!modules.getters['general/user'] ? modules.getters['general/user'].uid : '' } },
        root
    );
}
const rcPurchasesOrder = function (product) {
    commit('general/setLoading', true);
    product = product || modules.getters['purchases/products'][0];
    Purchases.purchasePackage(product,
        ({ customerInfo }) => {
            if (!!customerInfo.entitlements.active) {
                commit('purchases/setPurchasesModel', false);
                commit('general/setConfirmModel', {
                    active: true,
                    alert: true,
                    text: messages.PURCHASE_SUCCESS,
                    callback: async () => {
                        await commit("general/setLoadingOn");
                        await new Promise(resolve => setTimeout(resolve, 6000));
                        await modules.dispatch('general/refreshAccessToken', null, root);
                        commit('purchases/setRecentPurchase', true);
                    },
                    confirmText: mixin.methods._getLabel("CONTINUE"),
                });
            }
            commit('general/setLoading', false);
        },
        ({ error, userCancelled }) => {
            commit('general/setLoading', false);
            if (userCancelled) {
                return;
            }
            setStatusLabelText(error);
            modules.dispatch('general/refreshAccessToken', { loading: false }, root);
        });
}
const purchasesOrder = async (product) => {
    logEvent("purchasesOrder");
    if (_isCordovaApp()) {
        rcPurchasesOrder(product);
    } else {
        modules.dispatch('purchases/createCheckoutSession', product, root);
    }
}

const rcRestorePurchases = async () => {
    commit('general/setLoading', true);
    Purchases.restorePurchases(
        _info => {
            modules.dispatch('general/refreshAccessToken', null, root);
        },
        error => {
            commit('general/setLoading', false);
            setStatusLabelText(error);
        });
}

const rcManageSubscriptions = function () {
    Purchases.getCustomerInfo(
        customerInfo => {
            const managementURL = customerInfo.managementURL;
            modules.dispatch('general/openExternalUrl', { url: managementURL }, root);
        },
        error => {
            setStatusLabelText(error);
        }
    );
}

export {
    purchasesOrder,
    displayUpsellScreen,
    rcConfigureOrLogin,
    rcRestorePurchases,
    rcManageSubscriptions,
    initializeStripe
}